import { render } from "./About.vue?vue&type=template&id=081c0a7a&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=081c0a7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081c0a7a"]])

export default __exports__